import { Component, OnInit, ViewChild } from '@angular/core';
import { Session } from 'src/app/models/session';
import { Toast, ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { ConfirmService } from '../confirm/confirm.service';
import { MapChartComponent } from '../map-chart/map-chart.component';

@Component({
  selector: 'app-zonas',
  templateUrl: './zonas.component.html',
  styleUrls: ['./zonas.component.css']
})
export class ZonasComponent implements OnInit {

  @ViewChild('map',null) map:MapChartComponent;

  constructor(public session: Session, private toast: ToastrService, private service: UserService, private confirm: ConfirmService) { }

  provincias = ["Buenos Aires",
    "Catamarca",
    "Capital Federal",
    "Chaco",
    "Chubut",
    "Cordoba",
    "Corrientes",
    "Entre Rios",
    "Formosa",
    "Jujuy",
    "La Pampa",
    "La Rioja",
    "Mendoza",
    "Misiones",
    "Neuquen",
    "Rio Negro",
    "Salta",
    "San Juan",
    "San Luis",
    "Santa Cruz",
    "Santa Fe",
    "Santiago del Estero",
    "Tierra del Fuego",
    "Tucuman",];

    
  ngOnInit() {
    this.provincias.sort( (a,b) =>  { return (a > b ) ? 1 : -1 } );
    this.service.getZones().subscribe(d=>{
      this.zonas = d;
      this.selectedProvincia = this.provincias[0];
      this.getZonas();
      setTimeout(() => {
        this.map.updateMap();
      }, 1000);
    });
  }

  newProvincia = "";
  newLocalidad = "";
  selectedProvincia;

  zonas = [];

  localidades = [];



  getZonas(){

    let provincia = this.selectedProvincia;
    let a = this.zonas.filter(x=> x.provincia == provincia);
    this.localidades = a.sort( (a,b)=> { return (a.localidad > b.localidad ) ? 1 : -1 } );
  }

  addZone(){
    if(this.newLocalidad.length<1) return;
    let newZona: any = {provincia: this.selectedProvincia, localidad: this.newLocalidad};
    this.service.postZones(newZona).subscribe(d=>{
      newZona._id = d._id;
      this.zonas.push(newZona);
      this.zonas = JSON.parse(JSON.stringify(this.zonas));
      this.newProvincia = "";
      this.newLocalidad = "";
      this.getZonas();
    }, er =>{
      this.toast.error(er.error);
    })
  }
  

  borrarZona(zona){
    this.confirm.confirm("Eliminar zona","Esta seguro de eliminar la zona: " + zona.localidad + " ?").then( confirmed => {
      if(!confirmed) return;
      this.service.deleteZone(zona).subscribe(d=>{
        let i = this.zonas.findIndex(x=> x._id == zona._id);
        if(i>=0) this.zonas.splice(i,1);

        this.zonas = JSON.parse(JSON.stringify(this.zonas));
        this.getZonas();
      })
    }) 
  }

  saveChanges(zona){
    this.service.putZone(zona._id, zona.localidad).subscribe(d=>{
      zona.edited = false;
    }, er=>{
      this.toast.error("ERROR");
    })
  }

  getMapData(){
    return this.zonas;
  }
}
